
import { Component, Prop, Vue, Watch } from "vue-property-decorator";

@Component({})
export default class HinaSwitch extends Vue {
  @Prop() value!: any;
  @Prop() activeValue!: any;
  @Prop() inactiveValue!: any;
  @Prop({ default: true }) showLabel!: boolean;
  @Prop({ default: "开启" }) activeText!: string;
  @Prop({ default: "关闭" }) inactiveText!: string;
  @Prop({ default: "#262936" }) labelColor!: string;

  v = this.value;

  @Watch("value", { immediate: true })
  handleValueChange() {
    this.v = this.value;
  }

  handleChange() {
    this.$emit("update:value", this.v);
    this.$emit("change", this.v);
  }
}
